import React from "react";
import { toast } from "react-toastify";
import {
  GRID_SIZE,
  widgetDimensionsForWidgetTypes
} from "../../../../helpers/constants";
import {
  gridCoordsFromPosition,
  //positionFromGridCoords
} from "../../../../helpers/grid";
import UUID from "uuid";

import {
  MockedRadialGauge,
  MockedLinearGauge,
  MockedSimpleNumerical,
  MockedLineChart
} from "../Widgets";
import { MockedImageView } from "../Widgets/ImageView";

export default class WidgetBarItem extends React.PureComponent {
  // Dragging
  onWidgetDragStart(evt) {
    toast.warn("Drag the widet to the dashboard!");
    let { startDrag, widgetType } = this.props;
    let { clientX, clientY } = evt;

    let widgetid = UUID.v1();

    let widgetDimensions = widgetDimensionsForWidgetTypes(widgetType);
    let dragSource = {
      type: "widget",
      widgettype: widgetType,
      widgetid: widgetid,
      cursorOffsetX: -widgetDimensions.w / 2,
      cursorOffsetY: -widgetDimensions.h / 2
    };

    let gridOrigin = gridCoordsFromPosition(clientX, clientY, GRID_SIZE);

    this.props.addWidgetToDashboard(
      dragSource.widgettype,
      gridOrigin,
      widgetid
    );

    startDrag(clientX, clientY, dragSource);
  }

  widgetComponentForType(type) {
    switch (type) {
      case "alphanumeric":
        return MockedSimpleNumerical;

      case "radialgauge":
        return MockedRadialGauge;

      case "lineargauge":
        return MockedLinearGauge; 

      case "linechart":
        return MockedLineChart;

      case "imageview":
        return MockedImageView;

      default:
        return MockedSimpleNumerical;
    }
  }

  render() {
    let { widgetType, displayName } = this.props;
    let MockedWidgetComponent = this.widgetComponentForType(widgetType);
    return (
      <div
        className="widgetbar_item"
        onMouseDown={evt => {
          this.onWidgetDragStart.bind(this)(evt);
        }}
      >
        <MockedWidgetComponent label={displayName} widgetType={widgetType} />
      </div>

      /*       <button
        className="widgetbar_item"
        onMouseDown={evt => {
          this.onWidgetDragStart.bind(this)(evt);
        }}
      >
        {displayName}
      </button> */
    );
  }
}
